import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  results: [],
  selected: [],
  cleared: false,
  error: null,
};

export default reducerFactory(initialState, {
  [types.ADD_SELECTED_FILING_STATUS]: (state, action) => ({
    ...state,
    cleared: false,
    selected: action.response.filingStatus,
  }),
  [types.GET_FILING_STATUS_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.GET_FILING_STATUS_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    ...response.filingStatus,
  }),
  [types.GET_FILING_STATUS_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.REMOVE_ALL_FILING_STATUS]: state => ({
    ...state,
    cleared: true,
    selected: [],
  }),
});
